export function assertNever(name: string, x: never): never {
  throw new Error(`Unexpected ${name}: ${JSON.stringify(x, null, '  ')}`);
}
